// Read a `?demo=...` query flag from the current URL. Used by the
// mock-bidder fixture branches to demo edge-case states without a
// backend round-trip. Returns null when the flag is absent or when
// running outside a browser (SSR / unit tests).
//
// Hoisted from features/my-bids/api.ts and features/bid/store.ts so
// any feature can import via @/shell without cross-feature imports.
export function demoFlag(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return new URL(window.location.href).searchParams.get('demo');
  } catch {
    return null;
  }
}
